;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export type PermissionFlag = "canView" | "canCreate" | "canEdit" | "canDelete";

/** Pass `"*"` to require at least one of the four flags to be effectively true (OR). */
export type PermissionFlagsArg =
	| PermissionFlag
	| readonly PermissionFlag[]
	| "*";

export interface HasResourcePermissionOptions {
	/** Used when the resource row or a specific flag is missing. Defaults to false. */
	defaultValue?: boolean;
}

export const ALL_PERMISSION_FLAGS = [
	"canView",
	"canCreate",
	"canEdit",
	"canDelete",
] as const satisfies readonly PermissionFlag[];

export function effectivePermissionFlag(
	row: Partial<Record<PermissionFlag, boolean>> | undefined,
	flag: PermissionFlag,
	defaultValue: boolean,
): boolean {
	const raw = row?.[flag];
	return raw === undefined ? defaultValue : raw;
}

export function evaluatePermissionFlags(
	row: Partial<Record<PermissionFlag, boolean>> | undefined,
	flagOrFlags: PermissionFlagsArg,
	defaultValue: boolean,
): boolean {
	if (flagOrFlags === "*") {
		return ALL_PERMISSION_FLAGS.some((flag) =>
			effectivePermissionFlag(row, flag, defaultValue),
		);
	}

	const flags = (
		Array.isArray(flagOrFlags) ? flagOrFlags : [flagOrFlags]
	) as PermissionFlag[];

	return flags.every((flag) =>
		effectivePermissionFlag(row, flag, defaultValue),
	);
}

export function resolvePermissionResourceKey(entry: {
	name?: string;
	resource?: string;
}): string | undefined {
	return entry.name ?? entry.resource;
}
